import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { obtenerProductoRandom } from './Api';

export function Receta() {

    const [cocktail, setCocktail] = useState([]);

    useEffect(() => {
        obtenerProductoRandom().then(cocktail => setCocktail(cocktail))
    }, []);

    const {
        idDrink: id,
        strDrink: nombre,
        strDrinkThumb: imagen,
        strAlcoholic: alcoholica,
    } = cocktail;

    return (
        <>
            <Link className='text-light text-decoration-none' to={`/receta/${id}`}>
                <div class="card d-block receta-card">
                    <img class="card-img-top" src={imagen} alt='imagen del producto' />
                    <div class="card-body receta-body">
                        <h4 class="card-title receta-title"><b>{nombre}</b></h4>
                        <h5 class="card-text receta-text">{alcoholica}</h5>
                    </div>
                </div>
            </Link>
        </>
    )
}
